// src\app\models\address.model.ts

export class Address {
    
    constructor(
        public id: string | null,
        public title: string,
        public address: string,
        public landmark: string,
        public house: string,
        public lat: number,
        public lng: number,
        public uid?: string,
        // public created_at?: Date,
        // public updated_at?: Date
    ) {}

}